import { useCallback, useState } from 'react';

// Cycles an index across [primary/live photo, ...mlsPhotos]. index === -1 means the live photo.
export const usePhotoCarousel = (mlsPhotos) => {
  const [index, setIndex] = useState(-1);
  const total = mlsPhotos.length + 1;

  const goPrev = useCallback((e) => {
    e?.stopPropagation();
    setIndex((i) => (i === -1 ? mlsPhotos.length - 1 : i - 1));
  }, [mlsPhotos.length]);

  const goNext = useCallback((e) => {
    e?.stopPropagation();
    setIndex((i) => (i >= mlsPhotos.length - 1 ? -1 : i + 1));
  }, [mlsPhotos.length]);

  const reset = useCallback(() => setIndex(-1), []);

  return {
    index,
    setIndex,
    total,
    displayNumber: index + 2,
    hasMultiple: mlsPhotos.length > 0,
    goPrev,
    goNext,
    reset,
  };
};
